module.exports = __webpack_public_path__ + "media/fonts/avenir/Avenir-Book-0ca4bde6152be2629964eb413130bec9.ttf";